<template><div><h1>VUX V2.2.1Rc.6 发布日志</h1>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[feature] 支持 slot:inline-desc</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[enhance] display-format 支持 names 作为第二个参数</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[fix] 修复 popup 类名丢失问题</li>
<li>[feature] 支持 prop:show-mask 隐藏遮罩</li>
<li>[feature] 支持 prop:position 设定位置</li>
<li>[feature] 支持 prop:width 设定左右位置时的宽度</li>
</ul>
<h2><a href="/zh-CN/components/scroller.html">Scroller</a></h2>
<ul><li>[feature] 支持滚动到底部时触发事件 on-scroll-bottom</li>
<li>[fix] 禁止点击事件触发，修复 pc 上触发两次的问题</li>
</ul>
<h2><a href="/zh-CN/components/selector.html">Selector</a></h2>
<ul><li>[fix] 修复 placeholder 逻辑问题. #1273</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] 支持属性  display-format</li>
</ul>
<h2><a href="/zh-CN/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[enhance] 标签上对齐</li>
<li>[feature] 支持属性  prop:autosize 自动更新高度</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.6 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.6-229.vue?207db624